import BodyTypography from '../../../../Common/BodyTypography';
import GridRowNode from '../Common/GridRowNode';

interface ReasonItemProps {
    title: string;
    value: string;
}
function ReasonItem({ title, value }: ReasonItemProps) {
    return (
        <GridRowNode
            title={<BodyTypography>{title}:</BodyTypography>}
            node={<BodyTypography>{value}</BodyTypography>}
        />
    );
}

export default ReasonItem;
